import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as dealScreenErrorActionCreators from '@makemydeal/dr-dash-store/actions/dealScreenErrorActionCreators';
import { DealTabs } from '@makemydeal/dr-shared-types';
import type { CustomFeeItem } from './types';
import { DEFAULT_FEE_ROW_ERROR_STATE } from './utils';

/**
 * Custom hook to sync fee error states with Fees record
 *
 * @param categoryType - The fee category type (Government, Dealer, Lender)
 * @param fees - Array of fee items for this category
 * @param currentErrors - Current error state from Redux for this category
 * @param isEnabled - Whether error sync is enabled (feature flag)
 * @param condition - Additional condition to check for enabling error sync
 */
export const useFeeErrorSync = (
    categoryType: string,
    fees: CustomFeeItem[],
    currentErrors: Array<Record<string, boolean>>,
    isEnabled: boolean,
    condition: boolean = true
) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isEnabled || !condition) return;

        const updatedErrors = [];
        for (let i = 0; i < fees.length; i++) {
            updatedErrors.push({ ...DEFAULT_FEE_ROW_ERROR_STATE });
        }

        const hasChanges = JSON.stringify(currentErrors) !== JSON.stringify(updatedErrors);
        if (hasChanges) {
            const skipCategoryMerge = true;
            dispatch(
                dealScreenErrorActionCreators.setErrorFieldsByCategory(
                    DealTabs.FEES,
                    categoryType,
                    updatedErrors,
                    skipCategoryMerge
                )
            );
        }
    }, [isEnabled, condition, categoryType, JSON.stringify(fees)]);
};
